<template>
  <portal v-if="displayModal" to="modal-container">
    <transition :appear="true" name="mat">
      <Modal :separator="false" @close="closeModal">
        <div class="welcome-mat-container">
          <h1>
            <span class="bold">{{ $t('welcomeMat.title') }}</span>

            <span>
              {{
                $t('welcomeMat.CountryTitle', {
                  country: getCountryNameLabel(siteCountry).title
                })
              }}
            </span>
          </h1>

          <h2>{{ $t('welcomeMat.briefText') }}</h2>

          <div class="welcome-mat-promotion">
            <span v-for="title in $t('welcomeMat.promotionData')" :key="title">
              <Icons name="checkmark" style="--icon-size: 22px" />
              {{ title }}
            </span>
          </div>

          <div v-if="isShipping" class="shipping-country">
            {{
              $t('welcomeMat.shippingCountryMessage', {
                country: getCountryNameLabel(siteCountry).navLabel
              })
            }}

            <a :href="`https://${countryData[userCountry].domain}`">{{
              $t('welcomeMat.shippingCountryName', {
                country: getCountryNameLabel(userCountry).navLabel
              })
            }}</a>
          </div>

          <div v-else class="non-shipping-country">
            <p>{{ $t('welcomeMat.noShippingMessage') }}</p>

            <a href="/international">{{ $t('welcomeMat.clickHereText') }}</a>
            {{ $t('welcomeMat.findStoreText') }}
          </div>

          <Button
            :label="
              $t(`welcomeMat.${isShipping ? 'shippingCta' : 'nonShippingCta'}`)
            "
            :type="isShipping ? 'btn-primary' : 'btn-default'"
            @click="closeModal"
          />
        </div>
      </Modal>
    </transition>
  </portal>
</template>

<script>
import Modal from '@sephora-asia/core-modal/Modal.vue'
import Button from '@sephora-asia/core-button/Button.vue'
import Icons from '@sephora-asia/atoms-icons/Icons.vue'

export default {
  name: 'WelcomeMat',

  components: {
    Modal,
    Button,
    Icons
  },

  data() {
    return {
      displayModal: false
    }
  },

  computed: {
    siteCountry() {
      return this.$i18n?.countryCode
    },
    userCountry() {
      return this.$store.state?.globalConfig?.userOriginCountry
    },
    countryData() {
      return this.$store.getters?.['globalConfig/getCountriesData']
    },
    isShipping() {
      return this.countryData[this.userCountry]
    }
  },

  mounted() {
    if (!sessionStorage.getItem(`welcome-mat-shown-${this.siteCountry}`)) {
      this.displayModal =
        this.siteCountry &&
        this.userCountry &&
        this.siteCountry !== 'KR' &&
        this.userCountry !== this.siteCountry
    }
  },

  methods: {
    closeModal() {
      this.displayModal = false
      sessionStorage.setItem(`welcome-mat-shown-${this.siteCountry}`, 'true')
    },
    getCountryNameLabel(countryCode) {
      const countryData = this.$t('welcomeMat.addOnLabel')
      const defaultCountryLabel = this.countryData[countryCode]?.country
      const countryAddOnLabels = countryData?.[countryCode]

      return {
        title: countryAddOnLabels?.titleLabel || defaultCountryLabel,
        navLabel: countryAddOnLabels?.navLabel || defaultCountryLabel
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin bg_stripes {
  background: repeating-linear-gradient(
    black,
    black 20%,
    transparent 5%,
    transparent 40%
  );
  content: '';
  position: absolute;
  height: 100px;
  width: 100px;
  z-index: -1;

  @include mobile {
    display: none;
  }
}

.mat-enter-active,
.mat-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.mat-enter,
.mat-leave-to {
  opacity: 0;
}

.welcome-mat-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 10px auto 20px;
  min-height: 350px;
  text-align: center;

  &:before {
    @include bg_stripes();
    top: -65px;
    left: 0;
    clip-path: polygon(0 0, 100% 0, 10% 100%, 0% 100%);
  }

  &:after {
    @include bg_stripes();
    bottom: 0;
    right: 0;
    clip-path: polygon(90% 0, 100% 0, 100% 100%, 0% 100%);
  }

  a {
    text-decoration: underline;
  }

  h1 {
    font-family: 'Sephora Serif', Palatino, Georgia, Times;
    font-size: 34px;
    line-height: 36px;

    .bold {
      font-weight: 700;
    }
  }

  h2 {
    font-size: 20px;
    width: calc(max(70%, 250px));
    margin: 15px auto;
    line-height: 24px;
  }

  .welcome-mat-promotion {
    margin-bottom: 20px;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
    }
  }

  .shipping-country {
    order: 1;
    margin-top: 20px;
  }

  .non-shipping-country {
    margin-bottom: 20px;
  }

  @include mobile {
    gap: 0;
    margin-top: 0;
    min-height: auto;

    h1 {
      font-size: 32px;
    }
  }
}
</style>
